module.exports = __webpack_public_path__ + "media/app/assets/images/phone-mount-thumb-851c7b9accdb710611bb0ae15157eead.jpg";